import React from 'react';
import './KeyDerivationConsentModal.css';

const KeyDerivationConsentModal = ({ isOpen, onConsent, onCancel, chainName, accountExists, isFirstTime = true }) => {
    if (!isOpen) return null;

    // Determine title and message based on whether account exists
    // Capitalize first letter of chain name for message, preserving the rest of the
    // casing so acronyms like "BNB" / "HyperEVM" stay intact.
    const chainNameFormatted = chainName 
        ? chainName.charAt(0).toUpperCase() + chainName.slice(1)
        : '';
    const title = accountExists
        ? 'Enable Encryption'
        : chainName
            ? `Create Your ${chainName} Stabletrust Pay Account`
            : 'Create Your Stabletrust Pay Account';
    const message = accountExists
        ? 'Sign with your wallet to enable encryption.'
        : chainNameFormatted
            ? `Sign with your wallet to create your ${chainNameFormatted} Stabletrust Pay account.`
            : 'Sign with your wallet to create your Stabletrust Pay account.';

    return (
        <div className="key-consent-overlay">
            <div className="key-consent-modal">
                <div className="key-consent-header">
                    <h2>{title}</h2>
                </div>
                
                <div className="key-consent-content">
                    <p className="key-consent-intro">
                        {message}
                    </p>
                </div>
                
                <div className="key-consent-actions">
                    <button 
                        className="key-consent-cancel"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button 
                        className="key-consent-approve"
                        onClick={onConsent}
                    >
                        Sign
                    </button>
                </div>
            </div>
        </div>
    );
};

export default KeyDerivationConsentModal;

